module.exports = __webpack_public_path__ + "img/game.316567be.png";